import { render } from "./ThePatientPurchaseAuthorizationShow.vue?vue&type=template&id=35220614&scoped=true&ts=true"
import script from "./ThePatientPurchaseAuthorizationShow.vue?vue&type=script&lang=ts"
export * from "./ThePatientPurchaseAuthorizationShow.vue?vue&type=script&lang=ts"

import "./ThePatientPurchaseAuthorizationShow.vue?vue&type=style&index=0&id=35220614&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35220614"]])

export default __exports__